import { Link } from "react-router-dom";
import Seo from "@/components/site/Seo";
import SearchBar from "@/components/site/SearchBar";

export default function NotFound() {
  return (
    <div className="py-20 text-center sm:py-28">
      <Seo title="Not found — It's Genie Assist" noindex />
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-accent">404</p>
      <h1 className="mt-3 font-serif text-4xl font-medium tracking-tight text-ink sm:text-5xl">
        We couldn&apos;t find that page.
      </h1>
      <p className="mt-4 text-muted">Try searching for the brand you need.</p>
      <div className="mx-auto mt-8 max-w-xl">
        <SearchBar autoFocus size="compact" />
      </div>
      <Link to="/" className="mt-8 inline-block border-b border-ink font-mono text-xs uppercase tracking-widest hover:text-accent">
        ← Back home
      </Link>
    </div>
  );
}
